export const tagList = [
  'icebreaker',
  'team building',
  'trivia',
  'happy hour',
  'poll / survey',
  'company culture',
  'training & onboarding',
  'social event',
  'education',
  'seasonal & celebration',
  'employee wellness',
  'meeting / management',
  'team meetings',
  'conference / event',
  'brainstorming',
  'social gathering',
  'wellness',
  'classroom',
  'trivia & quiz'
]

export const vibeList = [
  'light & fun',
  'professional',
  'deep conversation',
  'competitive',
  'motivational',
  'social',
  'build connection',
  'new connections',
  'learning',
  'playful',
  'light Conversation'
]
